import { type Component, computed } from "vue";
import { toast, useVueSonner } from "vue-sonner";

declare module "vue-sonner" {
	export interface ToastT<T extends Component = Component> {
		mode?: "default" | "block";
	}
}

export const useNotifications = () => {
	const { activeToasts } = useVueSonner();

	const blocker = computed(() => activeToasts.value?.reverse()?.find((i) => i.mode === "block"));

	return {
		list: activeToasts,
		blocker: blocker,

		toast: toast,
		success: toast.success,
		info: toast.info,
		warning: toast.warning,
		error: toast.error,
		custom: toast.custom,
		message: toast.message,
		promise: toast.promise,
		dismiss: toast.dismiss,
		loading: toast.loading,

		getHistory: toast.getHistory,
		getToasts: toast.getToasts,
	};
};
